/* Scrivia Labs theme — behaviour. Vanilla JS, no dependencies.
   Everything here is progressive enhancement: the page reads fine with JS disabled. */
(function () {
  'use strict';

  var reducedMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionEnabled = document.documentElement.classList.contains('sl-motion');
  function reduced() { return reducedMQ.matches || !motionEnabled; }

  /* ---------- Analytics (no pixels; dataLayer only) ---------- */
  function track(name, props) {
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, props || {}));
      if (window.Shopify && window.Shopify.designMode) console.debug('[scrivia]', name, props || {});
    } catch (e) { /* noop */ }
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-sl-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-sl-menu-toggle]');
    var menu = header.querySelector('[data-sl-mobile-menu]');
    var sticky = header.querySelector('[data-sl-sticky-cta]');
    var contact = document.getElementById('contact');
    var nearForm = false, scrolled = false, open = false;

    function render() {
      header.classList.toggle('sl-header--scrolled', scrolled);
      if (sticky) {
        var show = scrolled && !open && !nearForm;
        sticky.classList.toggle('sl-sticky-cta--visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }
    }
    function onScroll() { scrolled = window.scrollY > 24; render(); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    if (contact && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { nearForm = e[0].isIntersecting; render(); }, { threshold: 0.15 }).observe(contact);
    }
    if (toggle && menu) {
      function setOpen(v) {
        open = v; menu.hidden = !v;
        requestAnimationFrame(function () { menu.classList.toggle('sl-header__mobile--open', v); });
        toggle.setAttribute('aria-expanded', String(v));
        toggle.setAttribute('aria-label', v ? 'Close menu' : 'Open menu');
        document.body.style.overflow = v ? 'hidden' : '';
        render();
      }
      toggle.addEventListener('click', function () { setOpen(!open); });
      menu.querySelectorAll('[data-sl-menu-close]').forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) setOpen(false); });
      window.matchMedia('(min-width: 881px)').addEventListener('change', function (e) { if (e.matches && open) setOpen(false); });
    }
  }

  /* ---------- CTA tracking + form preselect ---------- */
  function initCtas() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sl-cta]');
      if (!a) return;
      track('cta_click', { location: a.dataset.location, label: a.dataset.label });
      var pre = a.dataset.preselect;
      if (pre) {
        track('service_selected', { service: pre, location: a.dataset.location });
        var input = document.querySelector('[data-sl-form] input[data-key="interest"][value="' + pre + '"]');
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('.sl-reveal');
    if (!targets.length) return;
    if (reduced() || !('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Journey path (wave through N nodes) ---------- */
  function initJourney() {
    document.querySelectorAll('.sl-journey__stage').forEach(function (li, i) { li.style.setProperty('--n', i); });
    document.querySelectorAll('[data-sl-journey-path]').forEach(function (svg) {
      var n = parseInt(svg.dataset.count, 10) || 7, W = 1400, H = 120, step = W / n, x0 = step / 2;
      var d = 'M ' + (-step / 2) + ' ' + (H / 2);
      for (var i = 0; i < n; i++) {
        var x = x0 + i * step, prev = i === 0 ? -step / 2 : x0 + (i - 1) * step;
        d += ' Q ' + ((prev + x) / 2) + ' ' + (H / 2 + (i % 2 === 0 ? -34 : 34)) + ' ' + x + ' ' + (H / 2);
      }
      var endX = W + step / 2, last = x0 + (n - 1) * step;
      d += ' Q ' + ((last + endX) / 2) + ' ' + (H / 2 + (n % 2 === 0 ? -34 : 34)) + ' ' + endX + ' ' + (H / 2);
      svg.querySelectorAll('path').forEach(function (p) { p.setAttribute('d', d); });
    });
  }

  /* ---------- Step player (shared by hero demo + scenarios) ---------- */
  function createPlayer(opts) {
    var step = 0, playing = false, timer = null, onScreen = !opts.observe;
    function clear() { if (timer) { clearTimeout(timer); timer = null; } }
    function schedule() {
      clear();
      if (!playing || !onScreen) return;
      if (step >= opts.steps) {
        if (!opts.loop) { playing = false; opts.onPlay(false); return; }
        timer = setTimeout(function () { step = 0; opts.onStep(step); schedule(); }, opts.loopPause || 3200);
        return;
      }
      timer = setTimeout(function () { step += 1; opts.onStep(step); schedule(); }, step === 0 ? 500 : opts.interval);
    }
    var api = {
      get step() { return step; },
      get playing() { return playing; },
      play: function () { playing = true; opts.onPlay(true); schedule(); },
      pause: function () { playing = false; opts.onPlay(false); clear(); },
      toggle: function () { if (step >= opts.steps && !opts.loop) { api.replay(); return; } playing ? api.pause() : api.play(); },
      replay: function () { step = 0; opts.onStep(0); api.play(); },
      finish: function () { clear(); playing = false; step = opts.steps; opts.onStep(step); opts.onPlay(false); },
      reset: function (autoplay) { clear(); step = 0; opts.onStep(0); if (autoplay) api.play(); else { playing = false; opts.onPlay(false); } },
      setSteps: function (n) { opts.steps = n; }
    };
    if (opts.observe && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { onScreen = e[0].isIntersecting; if (onScreen && playing) schedule(); else clear(); }, { threshold: 0.08 }).observe(opts.observe);
    } else { onScreen = true; }
    return api;
  }

  /* ---------- Hero workflow demo ---------- */
  function initWorkflow() {
    document.querySelectorAll('[data-sl-workflow]').forEach(function (root) {
      if (root.dataset.slReady) return; root.dataset.slReady = '1';
      var STEPS = parseInt(root.dataset.steps, 10) || 6;
      var interval = parseInt(root.dataset.interval, 10) || 1500;
      var loop = root.dataset.loop !== 'false';
      var stage = root.querySelector('[data-wf-stage]');
      var svg = root.querySelector('[data-wf-river]');
      var paths = { base: svg.querySelector('[data-wf-path="base"]'), glow: svg.querySelector('[data-wf-path="glow"]'), lit: svg.querySelector('[data-wf-path="lit"]'), current: svg.querySelector('[data-wf-path="current"]') };
      var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-wf-node]'));
      var stepLabel = root.querySelector('[data-wf-step]');
      var toggleBtn = root.querySelector('[data-wf-toggle]');
      var replayBtn = root.querySelector('[data-wf-replay]');
      var narrowMQ = window.matchMedia('(max-width: 880px)');
      var fractions = [0, 0, 0];

      function measure() {
        var sr = stage.getBoundingClientRect();
        if (nodes.length < 3) return;
        if (narrowMQ.matches || sr.width < 600) {
          // Mobile: the river runs down the left edge (CSS line, top/bottom inset 8px); progress follows the stage nodes.
          Object.keys(paths).forEach(function (k) { paths[k].setAttribute('d', ''); });
          var h = Math.max(1, sr.height - 16);
          fractions = nodes.map(function (n) { var r = n.getBoundingClientRect(); return Math.min(100, Math.max(0, ((r.top - sr.top + r.height / 2 - 8) / h) * 100)); });
          return;
        }
        var pts = nodes.map(function (n) { var r = n.getBoundingClientRect(); return { x: r.left - sr.left + r.width / 2, y: r.top - sr.top + r.height / 2 }; });
        svg.setAttribute('viewBox', '0 0 ' + sr.width + ' ' + sr.height);
        svg.setAttribute('width', sr.width); svg.setAttribute('height', sr.height);
        function seg(p, q) { var dx = (q.x - p.x) * 0.5; return ' C ' + (p.x + dx) + ' ' + p.y + ', ' + (q.x - dx) + ' ' + q.y + ', ' + q.x + ' ' + q.y; }
        var a = pts[0], b = pts[1], c = pts[2];
        var d = 'M -24 ' + a.y + seg({ x: -24, y: a.y }, a) + seg(a, b) + seg(b, c) + seg(c, { x: sr.width + 24, y: c.y });
        Object.keys(paths).forEach(function (k) { paths[k].setAttribute('d', d); });
        var total = sr.width + 48;
        fractions = pts.map(function (p) { return ((p.x + 24) / total) * 100; });
      }

      function progressFor(s) {
        var f1 = fractions[0], f2 = fractions[1], f3 = fractions[2];
        var P = [0, f1, f1 + (f2 - f1) * 0.5, f2, f2 + (f3 - f2) * 0.33, f2 + (f3 - f2) * 0.66, 100];
        return P[Math.min(s, STEPS)] || 0;
      }

      function render(s) {
        root.dataset.step = s;
        root.querySelectorAll('[data-wf-on]').forEach(function (el) { el.classList.toggle('is-on', s >= +el.dataset.wfOn); });
        root.querySelectorAll('[data-wf-show]').forEach(function (el) { el.classList.toggle('show', s >= +el.dataset.wfShow); });
        root.querySelectorAll('[data-wf-hide]').forEach(function (el) { el.classList.toggle('hide', s >= +el.dataset.wfHide); });
        root.querySelectorAll('[data-wf-select]').forEach(function (el) { el.classList.toggle('is-selected', s >= +el.dataset.wfSelect); });
        root.querySelectorAll('[data-wf-active]').forEach(function (el) { el.classList.toggle('is-active', s >= +el.dataset.wfActive); });
        root.querySelectorAll('[data-wf-typing]').forEach(function (el) { el.classList.toggle('show', s === +el.dataset.wfTyping); });
        var p = progressFor(s);
        paths.glow.style.strokeDashoffset = 100 - p; paths.lit.style.strokeDashoffset = 100 - p;
        root.style.setProperty('--wf-p', (p / 100).toFixed(4));
        paths.current.style.opacity = s >= 1 ? 1 : 0;
        if (stepLabel) stepLabel.textContent = 'Step ' + Math.max(1, Math.min(s, STEPS)) + ' / ' + STEPS;
      }

      var player = createPlayer({
        steps: STEPS, interval: interval, loop: loop, observe: root,
        onStep: render,
        onPlay: function (p) { if (toggleBtn) { toggleBtn.dataset.playing = String(p); toggleBtn.setAttribute('aria-label', p ? 'Pause demo' : 'Play demo'); } }
      });

      function applyMode() {
        var isStatic = reduced();
        measure();
        root.dataset.static = String(isStatic);
        if (isStatic) player.finish(); else player.reset(true);
      }

      measure();
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(function () { measure(); render(player.step); }); ro.observe(stage); nodes.forEach(function (n) { ro.observe(n); }); }
      else window.addEventListener('resize', function () { measure(); render(player.step); });
      if (toggleBtn) toggleBtn.addEventListener('click', player.toggle);
      if (replayBtn) replayBtn.addEventListener('click', player.replay);
      narrowMQ.addEventListener('change', applyMode); reducedMQ.addEventListener('change', applyMode);
      applyMode();
    });
  }

  /* ---------- Scenario demo ---------- */
  var KIND_ICONS = {
    knowledge: '<path d="M3 3.5h4.5a1.5 1.5 0 0 1 1.5 1.5v8a1 1 0 0 0-1-1H3zM13 3.5H8.5A1.5 1.5 0 0 0 7 5v8a1 1 0 0 1 1-1h5z"/>',
    rules: '<path d="M8 2.5l5 2v4c0 2.8-2 4.6-5 5.5-3-.9-5-2.7-5-5.5v-4z"/>',
    availability: '<rect x="2.5" y="3.5" width="11" height="10" rx="1.5"/><path d="M2.5 7h11M5.5 2v3M10.5 2v3"/>',
    payment: '<rect x="2" y="4" width="12" height="8.5" rx="1.5"/><path d="M2 7h12M4.5 10h3"/>',
    confirmation: '<path d="M3 8.5l3 3 7-7"/>',
    handoff: '<circle cx="4.5" cy="5" r="2"/><circle cx="11.5" cy="5" r="2"/><path d="M2 13c.4-2 1.4-3 2.5-3s2.1 1 2.5 3M9 13c.4-2 1.4-3 2.5-3s2.1 1 2.5 3"/>',
    followup: '<path d="M4 11h8l-1-1.5V7a3 3 0 0 0-6 0v2.5z"/><path d="M6.8 13a1.3 1.3 0 0 0 2.4 0"/>'
  };
  function icon(kind, cls) { return '<svg class="sl-icon ' + (cls || '') + '" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (KIND_ICONS[kind] || KIND_ICONS.confirmation) + '</svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rows(text) { return String(text || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean).map(function (l) { var p = l.split('|'); return { k: (p[0] || '').trim(), v: (p.slice(1).join('|') || '').trim() }; }); }
  function ids(text) { return String(text || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }

  function initDemo() {
    document.querySelectorAll('[data-sl-demo]').forEach(function (root) {
      if (root.dataset.slReady) return; root.dataset.slReady = '1';
      var dataEl = root.querySelector('[data-demo-data]');
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!data.scenarios || !data.scenarios.length) return;
      var interval = parseInt(root.dataset.interval, 10) || 1700;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-demo-tab]'));
      var thread = root.querySelector('[data-demo-thread]'), team = root.querySelector('[data-demo-team]'), actions = root.querySelector('[data-demo-actions]');
      var title = root.querySelector('[data-demo-title]'), context = root.querySelector('[data-demo-context]');
      var toggleBtn = root.querySelector('[data-demo-toggle]'), replayBtn = root.querySelector('[data-demo-replay]'), controls = root.querySelector('[data-demo-controls]');
      var viewBtns = Array.prototype.slice.call(root.querySelectorAll('[data-demo-view]'));
      var current = data.scenarios[0], view = 'patient';

      function renderMessage(m) {
        if (m.from === 'note') return '<div class="sl-demo__note-line"><span class="sl-mono">' + esc(m.time) + '</span><span>' + esc(m.text) + '</span></div>';
        var card = '';
        if (m.card && m.card !== 'none') {
          var rs = rows(m.cardRows).map(function (r) { return '<div><dt>' + esc(r.k) + '</dt><dd class="' + (m.card === 'price' ? 'sl-mono' : '') + '">' + esc(r.v) + '</dd></div>'; }).join('');
          card = '<div class="sl-demo__card"><span class="sl-demo__card-title">' + esc(m.cardTitle) + '</span><dl class="sl-demo__card-rows">' + rs + '</dl>' + (m.card === 'price' && m.cardFoot ? '<span class="sl-demo__card-foot">' + esc(m.cardFoot) + '</span>' : '') + '</div>';
        }
        var who = m.from === 'assistant' ? 'assistant' : 'patient';
        return '<div class="sl-demo__msg sl-demo__msg--' + who + '"><div class="sl-demo__bubble sl-demo__bubble--' + who + '">' + esc(m.text) + card + '</div><span class="sl-mono sl-demo__time">' + (who === 'assistant' ? esc(data.labels.assistant) + ' · ' : '') + esc(m.time) + '</span></div>';
      }

      function renderStep(s) {
        var shown = current.messages.slice(0, s);
        var html = shown.map(renderMessage).join('');
        var last = shown[shown.length - 1];
        if (player.playing && s < current.messages.length && last && last.from === 'patient') html += '<div class="sl-demo__typing" aria-hidden="true"><i></i><i></i><i></i></div>';
        thread.innerHTML = html;
        var revealed = {};
        shown.forEach(function (m) { ids(m.actions).forEach(function (id) { revealed[id] = true; }); });
        // The team view shows the outcome, so every action reads as done.
        actions.querySelectorAll('[data-action-id]').forEach(function (li) { li.classList.toggle('is-on', view === 'team' || !!revealed[li.dataset.actionId]); });
      }

      function renderActions() {
        actions.innerHTML = current.actions.map(function (a) {
          return '<li class="sl-demo__action" data-action-id="' + esc(a.id) + '"><span class="sl-demo__action-icon">' + icon(a.kind) + '</span><div class="sl-demo__action-body"><span class="sl-mono sl-demo__action-kind">' + esc(data.labels.kinds[a.kind] || a.kind) + '</span><span class="sl-demo__action-title">' + esc(a.title) + '</span><p class="sl-demo__action-detail">' + esc(a.detail) + '</p></div><span class="sl-demo__action-state" aria-hidden="true">' + icon('confirmation') + '</span></li>';
        }).join('');
      }

      function renderTeam() {
        var t = current.team || {};
        team.innerHTML = '<div class="sl-demo__team-card"><header class="sl-demo__team-head"><span class="sl-demo__team-title">' + icon('knowledge') + ' ' + esc(t.title) + '</span><span class="sl-mono">Clinic team</span></header><dl class="sl-demo__team-rows">' +
          rows(t.rows).map(function (r) { return '<div class="sl-demo__team-row"><dt class="sl-mono">' + esc(r.k) + '</dt><dd>' + esc(r.v) + '</dd></div>'; }).join('') +
          '</dl>' + (t.note ? '<p class="sl-demo__team-note">' + esc(t.note) + '</p>' : '') + '</div><p class="sl-demo__team-foot">' + esc(data.labels.teamFoot) + '</p>';
      }

      function setView(v) {
        view = v;
        viewBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.demoView === v)); });
        thread.hidden = v !== 'patient'; team.hidden = v !== 'team';
        if (controls) controls.style.visibility = v === 'patient' && !reduced() ? '' : 'hidden';
        if (v === 'team') renderTeam();
        if (player) renderStep(player.step);
      }

      var player = createPlayer({
        steps: current.messages.length, interval: interval, loop: false, observe: root,
        onStep: renderStep,
        onPlay: function (p) { if (toggleBtn) { toggleBtn.dataset.playing = String(p); toggleBtn.setAttribute('aria-label', p ? 'Pause' : 'Play'); } if (!p) renderStep(player.step); }
      });

      function load(key) {
        current = data.scenarios.filter(function (s) { return s.key === key; })[0] || data.scenarios[0];
        tabs.forEach(function (t) { var on = t.dataset.demoTab === current.key; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        title.textContent = current.title || ''; context.textContent = current.context || '';
        renderActions(); player.setSteps(current.messages.length);
        setView('patient');
        if (reduced()) player.finish(); else player.reset(true);
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { load(t.dataset.demoTab); track('demo_scenario_selected', { scenario: t.dataset.demoTab }); });
        t.addEventListener('keydown', function (e) {
          var j = i;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length; else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length; else return;
          e.preventDefault(); tabs[j].focus(); tabs[j].click();
        });
      });
      viewBtns.forEach(function (b) { b.addEventListener('click', function () { setView(b.dataset.demoView); }); });
      if (toggleBtn) toggleBtn.addEventListener('click', player.toggle);
      if (replayBtn) replayBtn.addEventListener('click', player.replay);
      load(data.scenarios[0].key);
    });
  }

  /* ---------- Local currency ----------
     Prices are written in USD. Visitors in these countries see them converted at the day's ECB rate,
     rounded to the nearest 10. Country from Shopify's geolocation (or ?country=XX for tests and ad links). */
  var CURRENCY_BY_COUNTRY = { GB: 'GBP', GG: 'GBP', JE: 'GBP', IM: 'GBP', GI: 'GBP', CA: 'CAD', AU: 'AUD' };
  // Every other European country sees EUR (euro area, rest of the EU/EEA, Switzerland and the Balkans).
  'AD AL AT BA BE BG CH CY CZ DE DK EE ES FI FO FR GR HR HU IE IS IT LI LT LU LV MC MD ME MK MT NL NO PL PT RO RS SE SI SK SM UA VA XK'
    .split(' ').forEach(function (c) { CURRENCY_BY_COUNTRY[c] = 'EUR'; });
  function cacheGet(key) {
    try { var o = JSON.parse(localStorage.getItem(key) || 'null'); return o && o.exp > Date.now() ? o.v : null; } catch (e) { return null; }
  }
  function cacheSet(key, value, hours) {
    try { localStorage.setItem(key, JSON.stringify({ v: value, exp: Date.now() + hours * 3600000 })); } catch (e) { /* private mode */ }
  }
  function detectCountry() {
    var forced = (new URLSearchParams(location.search).get('country') || '').toUpperCase();
    if (/^[A-Z]{2}$/.test(forced)) { cacheSet('sl-country', forced, 6); return Promise.resolve(forced); }
    var cached = cacheGet('sl-country');
    if (cached) return Promise.resolve(cached);
    return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (c) cacheSet('sl-country', c, 6);
        return c;
      });
  }
  function usdRate(currency) {
    var cached = cacheGet('sl-rate-' + currency);
    if (cached) return Promise.resolve(cached);
    return fetch('https://api.frankfurter.dev/v1/latest?base=USD&symbols=' + currency)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rate = d && d.rates && d.rates[currency];
        if (rate) cacheSet('sl-rate-' + currency, rate, 12);
        return rate;
      });
  }
  // Converted prices round UP to the next figure ending in 90 (1,134 → 1,190), so they never fall below the USD price.
  function endIn90(v) { return Math.max(90, Math.ceil((v - 90) / 100) * 100 + 90); }
  function convertPrices(currency, rate) {
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
    var amount = /\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{2})?/g;
    document.querySelectorAll('[data-sl-money]:not([data-sl-converted])').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (n) {
        if (n.nodeValue.indexOf('$') === -1) return;
        n.nodeValue = n.nodeValue.replace(amount, function (m, num) {
          return fmt.format(endIn90(parseFloat(num.replace(/,/g, '')) * rate));
        });
      });
      el.setAttribute('data-sl-converted', currency);
    });
  }
  function initPrices() {
    if (document.body.dataset.slCurrency !== 'auto' || !document.querySelector('[data-sl-money]')) return Promise.resolve();
    return detectCountry().then(function (country) {
      var currency = CURRENCY_BY_COUNTRY[country];
      if (!currency) return;
      return usdRate(currency).then(function (rate) {
        if (!rate) return;
        convertPrices(currency, rate);
        document.documentElement.setAttribute('data-sl-currency', currency);
        track('local_currency_shown', { currency: currency, country: country });
      });
    }).catch(function () { /* prices stay in USD */ });
  }

  /* ---------- Motion layer: staggered lists and count-ups ---------- */
  var STAGGER = '.sl-eng__list, .sl-def__pillars, .sl-problem__gaps, .sl-scope__items, .sl-scope__doc-rows, .sl-control__principles, .sl-control__questions, .sl-report__metrics, .sl-journey__stages, .sl-faq__list, .sl-contact__expect';
  function initStagger() {
    var lists = Array.prototype.slice.call(document.querySelectorAll(STAGGER)).filter(function (el) { return !el.classList.contains('sl-stagger'); });
    if (!lists.length) return;
    lists.forEach(function (el) {
      el.classList.add('sl-stagger');
      Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--i', Math.min(i, 8)); });
    });
    if (reduced() || !('IntersectionObserver' in window)) { lists.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    lists.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.sl-eng__price-amount, .sl-process__example .sl-report__metric-value, .sl-report__metric-value[data-sl-count]')).filter(function (el) { return !el.dataset.slCounted; });
    if (!els.length || reduced() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, final = el.textContent.trim(), m = final.match(/^(\D*?)(\d[\d,]*)(\D*)$/);
        if (!m) return;
        var target = parseInt(m[2].replace(/,/g, ''), 10), start = null, dur = 1100;
        function frame(ts) {
          if (start === null) start = ts;
          var k = Math.min(1, (ts - start) / dur), eased = 1 - Math.pow(1 - k, 3);
          el.textContent = k < 1 ? m[1] + Math.round(target * eased).toLocaleString('en-US') + m[3] : final;
          if (k < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { el.dataset.slCounted = '1'; io.observe(el); });
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    document.querySelectorAll('[data-sl-faq]').forEach(function (list) {
      if (list.dataset.slReady) return; list.dataset.slReady = '1';
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-faq-trigger]'); if (!btn) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('[data-faq-trigger]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); document.getElementById(b.getAttribute('aria-controls')).classList.remove('sl-faq__a--open'); });
        if (!open) { btn.setAttribute('aria-expanded', 'true'); document.getElementById(btn.getAttribute('aria-controls')).classList.add('sl-faq__a--open'); }
      });
    });
  }

  /* ---------- Enquiry form ----------
     data-mode: "shopify" → native POST to /contact (Shopify emails the store; the success state is rendered
     server-side only after Shopify accepts it), "webhook" → JSON POST to data-endpoint, "preview" → nothing is sent.
     In Shopify mode a configured endpoint receives the JSON too, before the native POST.
     After sending, qualified enquiries (a listed country, not the "just exploring" start option) get an inline
     Cal.com calendar; the rest get the email-reply message. Fields are addressed by data-key because Shopify
     needs contact[…] names. */
  var ENQUIRY_KEY = 'sl-enquiry';
  function sessionGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sessionSet(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }

  /* Ad attribution: UTM tags (and whether the visit came from a Meta ad click) are kept for the session, so the
     enquiry email, the booking notes and the webhook say where the lead came from — Shopify's reload after the
     form drops the URL. */
  var ATTR_KEY = 'sl-attribution', UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function captureAttribution() {
    var p = new URLSearchParams(location.search), a = {};
    UTM.forEach(function (k) { var v = p.get(k); if (v) a[k] = v.slice(0, 120); });
    if (p.get('fbclid')) a.meta_click = true;
    if (Object.keys(a).length) sessionSet(ATTR_KEY, a);
  }
  function attributionText(a) {
    a = a || {}; var parts = a.meta_click ? ['Meta ad click'] : [];
    UTM.forEach(function (k) { if (a[k]) parts.push(k.replace('utm_', '') + ': ' + a[k]); });
    return parts.length ? parts.join(' · ') : 'No ad or campaign tags';
  }

  /* Meta events (Theme settings → Meta ads). They go through the pixel that Shopify's Facebook & Instagram app
     puts on the page, which follows the cookie banner: no pixel, or no marketing consent → nothing is sent. */
  function metaEvent(name, params, eventId) {
    var b = document.body.dataset;
    if (b.metaEvents !== 'true') return;
    var pixel = (b.metaPixel || '').trim(), custom = ['Lead', 'Schedule', 'Contact'].indexOf(name) === -1, tries = 0;
    (function send() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function' && !cp.marketingAllowed()) return;
      if (typeof window.fbq !== 'function') { if (++tries < 40) setTimeout(send, 250); return; } // the app loads it a moment after the page
      var opts = eventId ? { eventID: eventId } : {};
      if (pixel) window.fbq(custom ? 'trackSingleCustom' : 'trackSingle', pixel, name, params || {}, opts);
      else window.fbq(custom ? 'trackCustom' : 'track', name, params || {}, opts);
    })();
  }

  function loadCal() {
    if (window.Cal) return;
    // Cal.com's embed loader (queues calls until embed.js arrives).
    (function (C, A, L) {
      var p = function (a, ar) { a.q.push(ar); }, d = C.document;
      C.Cal = C.Cal || function () {
        var cal = C.Cal, ar = arguments;
        if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; }
        if (ar[0] === L) {
          var api = function () { p(api, arguments); }, namespace = ar[1]; api.q = api.q || [];
          if (typeof namespace === 'string') { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ['initNamespace', namespace]); } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
  }
  function bookingNotes(d) {
    return [['Clinic', d.clinic], ['Phone', d.phone], ['Country', d.country], ['Service interest', d.interestLabel], ['Patient enquiries today', d.acquisitionLabel],
      ['Looking to start', d.timelineLabel], ['Website', d.website], ['Monthly enquiries', d.volumeLabel], ['Source', attributionText(d.attribution)]]
      .filter(function (r) { return r[1]; }).map(function (r) { return r[0] + ': ' + r[1]; }).join('\n');
  }
  function showCalendar(el, calLink, d) {
    loadCal();
    var ns = 'scrivia', booked = false;
    var aqua = getComputedStyle(document.documentElement).getPropertyValue('--aqua').trim() || '#57D5C9';
    window.Cal('init', ns, { origin: 'https://app.cal.com' });
    window.Cal.config = window.Cal.config || {};
    window.Cal.config.forwardQueryParams = true; // UTM parameters from ads reach the booking
    var config = { layout: 'month_view', useSlotsViewOnSmallScreen: 'true', theme: 'dark', name: d.name, email: d.email, notes: bookingNotes(d) };
    if (d.phone) config.attendeePhoneNumber = d.phone; // used if the Cal event asks for a phone number
    UTM.forEach(function (k) { if (d.attribution && d.attribution[k]) config[k] = d.attribution[k]; }); // Cal stores UTM tags on the booking
    window.Cal.ns[ns]('inline', { elementOrSelector: '#' + el.id, calLink: calLink, config: config });
    window.Cal.ns[ns]('ui', { theme: 'dark', layout: 'month_view', hideEventTypeDetails: false, cssVarsPerTheme: { dark: { 'cal-brand': aqua } } });
    function onBooked() {
      if (booked) return; booked = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'call_booked', interest: d.interest, country: d.country, timeline: d.timeline, cal_link: calLink });
      metaEvent('Schedule', { content_name: 'Strategy call', content_category: d.interestLabel || '', country: d.country || '' }, d.eventId ? d.eventId + '-call' : null);
    }
    window.Cal.ns[ns]('on', { action: 'bookingSuccessfulV2', callback: onBooked });
    window.Cal.ns[ns]('on', { action: 'bookingSuccessful', callback: onBooked });
  }

  function initForm() {
    document.querySelectorAll('[data-sl-form]').forEach(function (form) {
      if (form.dataset.slReady) return; form.dataset.slReady = '1';
      var mode = form.dataset.mode || 'preview';
      var endpoint = (form.dataset.endpoint || '').trim();
      function field(key) { return form.querySelector('[data-key="' + key + '"]'); }
      function val(key) { var el = field(key); return el ? (el.value || '').trim() : ''; }
      function picked(key) { return form.querySelector('input[data-key="' + key + '"]:checked'); }
      var submit = form.querySelector('[data-form-submit]');
      var results = { success: form.querySelector('[data-form-result="success"]'), outcome: form.querySelector('[data-form-result="outcome"]'), preview: form.querySelector('[data-form-result="preview"]'), error: form.querySelector('[data-form-result="error"]') };
      var fields = form.querySelector('[data-form-fields]'), foot = form.querySelector('[data-form-foot]');
      var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, URLish = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([\/?#].*)?$/i, PHONE = /^\+?[\d\s().-]{7,24}$/;

      function errEl(input) { var wrap = input.closest('.sl-contact__field, .sl-contact__fieldset'); return wrap ? wrap.querySelector('.sl-contact__error') : null; }
      function setError(input, msg) {
        var wrap = input.closest('.sl-contact__field, .sl-contact__fieldset'); var el = errEl(input);
        if (el) el.textContent = msg || '';
        if (wrap) wrap.classList.toggle('sl-contact__field--error', !!msg);
        if (input.tagName !== 'FIELDSET') { if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
      }
      function validateInput(input) {
        var v = (input.value || '').trim();
        if (input.required && !v) return input.dataset.error || 'Required';
        if (input.type === 'email' && v && !EMAIL.test(v)) return input.dataset.errorFormat || 'Invalid email';
        if (input.dataset.key === 'website' && v && !URLish.test(v)) return input.dataset.errorFormat || 'Invalid URL';
        if (input.dataset.key === 'phone' && v && (!PHONE.test(v) || v.replace(/\D/g, '').length < 7)) return input.dataset.errorFormat || 'Invalid phone';
        return '';
      }
      function validateAll() {
        var first = null;
        form.querySelectorAll('input[data-key], select[data-key]').forEach(function (input) {
          if (input.type === 'radio' || input.dataset.key === 'company') return;
          var msg = validateInput(input); setError(input, msg); if (msg && !first) first = input;
        });
        form.querySelectorAll('fieldset[data-field]').forEach(function (fs) {
          var msg = fs.querySelector('input[type="radio"]:checked') ? '' : (fs.dataset.error || 'Required');
          setError(fs, msg);
          if (msg && !first) first = fs.querySelector('input[type="radio"]');
        });
        return first;
      }
      form.querySelectorAll('input[data-key], select[data-key]').forEach(function (input) {
        if (input.type === 'radio') { input.addEventListener('change', function () { var fs = input.closest('fieldset'); if (fs) setError(fs, ''); }); return; }
        input.addEventListener('blur', function () { setError(input, validateInput(input)); });
        input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) setError(input, validateInput(input)); });
      });

      function show(kind) {
        Object.keys(results).forEach(function (k) { if (results[k]) results[k].hidden = k !== kind; });
        if (results[kind]) { results[kind].focus(); }
      }
      function busy(v) { submit.setAttribute('aria-busy', String(v)); submit.disabled = v; }

      function collect() {
        var i = picked('interest'), a = picked('acquisition'), t = picked('timeline'), vol = field('volume');
        return {
          name: val('name'), email: val('email'), clinic: val('clinic'), country: val('country'),
          interest: i ? i.value : null, interestLabel: i ? (i.dataset.label || i.value) : '',
          acquisition: a ? a.value : null, acquisitionLabel: a ? (a.dataset.label || a.value) : '',
          timeline: t ? t.value : null, timelineLabel: t ? (t.dataset.label || t.value) : '', noCall: !!(t && t.dataset.noCall === 'true'),
          phone: val('phone') || null, website: val('website') || null, volume: vol ? vol.value : null,
          volumeLabel: vol && vol.selectedIndex >= 0 ? vol.options[vol.selectedIndex].text : '',
          attribution: sessionGet(ATTR_KEY) || {}
        };
      }
      function payloadFrom(d) {
        return { name: d.name, email: d.email, clinic: d.clinic, country: d.country, interest: d.interest, acquisition: d.acquisition, timeline: d.timeline,
          phone: d.phone, website: d.website, volume: d.volume, source: 'shopify-landing', attribution: d.attribution, meta_event_id: d.eventId,
          page: location.href, submittedAt: new Date().toISOString() };
      }
      function qualifies(d) {
        if (!d || form.dataset.calendar !== 'true' || !form.dataset.calLink) return false;
        var list = (form.dataset.calCountries || '').split('|').map(function (c) { return c.trim().toLowerCase(); }).filter(Boolean);
        return !d.noCall && list.indexOf((d.country || '').trim().toLowerCase()) !== -1;
      }
      function renderOutcome(d) {
        var box = results.outcome; if (!box) return;
        var title = box.querySelector('[data-outcome-title]'), call = box.querySelector('[data-outcome-call]'), noCall = box.querySelector('[data-outcome-body="no-call"]');
        var ok = qualifies(d), first = ((d && d.name) || '').trim().split(/\s+/)[0], tpl = title.dataset.template || title.textContent;
        title.textContent = first ? tpl.replace(/\[name\]/gi, first) : tpl.replace(/,?\s*\[name\]/gi, '');
        if (fields) fields.hidden = true; if (foot) foot.hidden = true;
        if (results.success) results.success.hidden = true;
        if (call) call.hidden = !ok; if (noCall) noCall.hidden = ok;
        box.hidden = false;
        if (ok && call) { showCalendar(call.querySelector('[data-cal-inline]'), form.dataset.calLink, d); track('calendar_shown', { country: d.country, timeline: d.timeline }); }
        box.focus();
      }
      function fireLead(d) {
        d = d || {}; var ok = qualifies(d);
        var params = { content_name: 'Strategy call request', content_category: d.interestLabel || '', country: d.country || '', lead_quality: ok ? 'qualified' : 'standard' };
        metaEvent('Lead', params, d.eventId);
        if (ok) metaEvent('QualifiedLead', params, d.eventId ? d.eventId + '-q' : null);
      }

      // Pop-up: links to this section open the form on top of the page (Enquiry form → "Open the form in a pop-up").
      var dialog = form.dataset.modal === 'true' ? document.querySelector('[data-sl-modal]') : null;
      if (dialog && typeof dialog.showModal !== 'function') dialog = null;
      var anchor = (form.closest('section') || {}).id || 'contact', home = document.createComment('sl-form'), opener = null;
      function openModal(trigger) {
        if (!dialog || dialog.open) return;
        opener = trigger || null;
        form.parentNode.insertBefore(home, form);
        dialog.querySelector('[data-sl-modal-body]').appendChild(form);
        form.classList.add('is-visible');
        document.documentElement.classList.add('sl-modal-open');
        dialog.showModal();
        var nameInput = field('name');
        if (window.matchMedia('(pointer: fine)').matches && nameInput && !fields.hidden) nameInput.focus(); // no keyboard pop-up on phones
        track('enquiry_form_open', { location: trigger && trigger.dataset ? trigger.dataset.location || 'link' : 'after-send' });
      }
      function settle() { // put the form back in the section (runs once per close)
        if (home.parentNode) { home.parentNode.insertBefore(form, home); home.parentNode.removeChild(home); }
        document.documentElement.classList.remove('sl-modal-open');
        if (opener && opener.focus) opener.focus({ preventScroll: true });
        opener = null;
      }
      function closeModal() { if (dialog.open) dialog.close(); settle(); }
      if (dialog) {
        dialog.addEventListener('close', settle);
        dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(); }); // Esc
        dialog.querySelector('[data-sl-modal-close]').addEventListener('click', closeModal);
        dialog.addEventListener('click', function (e) { // click on the backdrop
          if (e.target !== dialog) return;
          var r = dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeModal();
        });
        document.addEventListener('click', function (e) {
          var a = e.target.closest('a[href*="#"]');
          if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || dialog.contains(a)) return;
          var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
          if (url.hash !== '#' + anchor || url.pathname !== location.pathname) return;
          e.preventDefault();
          if (a.closest('[data-sl-header]') || a.dataset.location === 'hero') { // header and hero buttons take the visitor down to the form
            form.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
            track('enquiry_form_scroll', { location: a.dataset.location || 'header' });
            return;
          }
          openModal(a);
        });
      }
      // Back from Shopify's POST: tidy the URL (a refresh shouldn't repeat it) and, if the form was sent from the
      // pop-up, reopen it where the visitor was instead of at the bottom of the page.
      function afterPost(d) {
        try { var u = new URL(location.href); u.searchParams.delete('contact_posted'); history.replaceState(null, '', u.pathname + u.search); } catch (e) { /* old browser */ }
        if (!d || d.via !== 'modal' || !dialog) return;
        var y = d.scrollY || 0, root = document.documentElement;
        function jump() { root.style.scrollBehavior = 'auto'; window.scrollTo(0, y); root.style.scrollBehavior = ''; }
        jump(); window.addEventListener('load', jump);
        openModal(null);
      }
      function refill(d) {
        ['name', 'email', 'phone', 'clinic', 'country', 'website'].forEach(function (k) { var el = field(k); if (el && d[k]) el.value = d[k]; });
        ['interest', 'acquisition', 'timeline'].forEach(function (k) {
          form.querySelectorAll('input[data-key="' + k + '"]').forEach(function (i) { if (i.value === d[k]) i.checked = true; });
        });
      }
      function sendWebhook(payload) {
        var ctrl = 'AbortController' in window ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
        return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (timer) clearTimeout(timer); if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
      }

      // Shopify mode: the page reloads after the POST; show the outcome for the enquiry saved before sending.
      if (mode === 'shopify' && results.success && !results.success.hidden) {
        track('enquiry_submitted', { channel: 'shopify' });
        var saved = sessionGet(ENQUIRY_KEY); sessionSet(ENQUIRY_KEY, null);
        afterPost(saved); fireLead(saved);
        if (saved) renderOutcome(saved); else results.success.focus();
      } else if (mode === 'shopify' && results.error && !results.error.hidden) {
        var failed = sessionGet(ENQUIRY_KEY); // Shopify refused it: back to the form, answers kept
        if (failed) { refill(failed); afterPost(failed); }
      }
      window.addEventListener('pageshow', function () { busy(false); }); // back/forward cache

      form.addEventListener('submit', function (e) {
        var first = validateAll();
        var honeypot = field('company');
        if (first || (honeypot && honeypot.value) || mode !== 'shopify' || endpoint) e.preventDefault();
        if (first) { setTimeout(function () { first.focus(); }, 0); return; }
        if (honeypot && honeypot.value) return;
        var d = collect();
        d.eventId = 'lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); // shared with the webhook for deduplication
        d.via = dialog && dialog.open ? 'modal' : 'page'; d.scrollY = window.scrollY;
        var payload = payloadFrom(d), source = form.querySelector('input[name="contact[Source]"]');
        if (source) source.value = 'Website enquiry form · ' + attributionText(d.attribution);
        if (mode === 'shopify') {
          sessionSet(ENQUIRY_KEY, d); busy(true);
          if (!endpoint) return; // native POST to /contact continues
          var native = function () { HTMLFormElement.prototype.submit.call(form); };
          sendWebhook(payload).then(native, native);
          return;
        }
        if (mode !== 'webhook' || !endpoint) { show('preview'); track('enquiry_preview_blocked', {}); renderOutcome(d); results.preview.hidden = false; return; }
        busy(true);
        sendWebhook(payload)
          .then(function () { busy(false); track('enquiry_submitted', { interest: payload.interest, country: payload.country }); fireLead(d); renderOutcome(d); })
          .catch(function () { busy(false); show('error'); });
      });
    });
  }

  function init() { captureAttribution(); initHeader(); initCtas(); initReveal(); initStagger(); initJourney(); initWorkflow(); initDemo(); initFaq(); initForm(); initPrices().then(initCountUp, initCountUp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Re-init when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', function () { initReveal(); initStagger(); initJourney(); initWorkflow(); initDemo(); initFaq(); initForm(); initPrices().then(initCountUp, initCountUp); });
})();
